/**
 * サンプルCSV
 */

export const sample =
  'https://s3-us-west-2.amazonaws.com/assets.anpichecker.com/sample.csv';
